<template>
  <div class="ticketGroups">
    <CheckInput
      type="button"
      class="ticketGroup"
      v-for="(group, key) in ticketGroups"
      :key="group.id"
      :fname="key"
      :model-value="group.selected"
      @update:model-value="(v) => setGroupFilterLocal({ key, selected: v })"
      :label="group.name"
    ></CheckInput>
    <RadioInput
      type="link"
      class="category reset"
      v-if="!noCategoriesSelected"
      :value="!noCategoriesSelected"
      fname="all"
      v-on:input="resetCategoriesLocal()"
      :label="$t('RESET_CATEGORY')"
    ></RadioInput>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CheckInput from '../Form/CheckInput.vue';
import RadioInput from '../Form/RadioInput.vue';

export default {
  name: 'TicketGroups',
  data() {
    return {};
  },
  components: { CheckInput, RadioInput },
  computed: {
    ...mapState({
      ticketGroups: (state) => state.tickets.data.ticketGroups,
    }),
    noCategoriesSelected() {
      const found = Object.keys(this.ticketGroups).find((k) => {
        if (this.ticketGroups[k].selected) {
          return true;
        }
        return false;
      });
      if (found) {
        return false;
      }
      return true;
    },
  },
  emits: ['routeResponsiveness'],
  methods: {
    ...mapActions({
      setTicketGroupFilter: 'tickets/setTicketGroupFilter',
    }),
    setGroupFilterLocal(v) {
      this.setTicketGroupFilter(v).then(() => {
        this.setUrlParams();
      });
    },
    setUrlParams() {
      let category;
      Object.keys(this.ticketGroups).find((k) => {
        if (this.ticketGroups[k].selected) {
          category = this.ticketGroups[k].name;
          return true;
        }
        return false;
      });

      const query = this.$route.query;
      //This allows to change the url without reloading components
      query.category = category;
      this.$router.replace({ ...this.$router.currentRoute, query });
      const newURL = this.$router.resolve({ ...this.$router.currentRoute, query }).fullPath;
      window.history.replaceState(null, '', newURL);
    },
    getUrlParams() {
      const { query } = this.$route;
      if (typeof query === 'undefined') {
        return;
      }
      Object.keys(this.ticketGroups).find((k) => {
        if (this.ticketGroups[k].name === query.category) {
          this.setTicketGroupFilter({ key: k, selected: true });
          return true;
        }
        return false;
      });
    },
    resetCategoriesLocal() {
      Object.keys(this.ticketGroups).find((k) => {
        this.setTicketGroupFilter({ key: k, selected: false });
        return true;
      });
      this.setUrlParams();
    },
  },
  watch: {
    ticketGroups() {
      this.getUrlParams();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.ticketGroups {
  margin-top: $sp;
  margin-bottom: $sp * 0.75;
  .ticketGroup {
    margin-right: 2.5px;
    margin-left: 2.5px;
  }
}
.reset {
  margin-left: 1ch;
}
</style>
